import EmblaCarousel from 'embla-carousel';

export function useEmblaCarousel(options = {}, autoplayInterval = 3000) {
	const emblaNode = ref(null);
	const emblaInstance = ref(null);
	let autoplayTimer = null;

	const scrollNext = () => emblaInstance.value?.scrollNext();
	const scrollPrev = () => emblaInstance.value?.scrollPrev();

	const handleKeyDown = (event) => {
		if (event.key === 'ArrowRight') {
			scrollNext();
		} else if (event.key === 'ArrowLeft') {
			scrollPrev();
		}
	};

	const startAutoplay = () => {
		stopAutoplay();
		autoplayTimer = setInterval(() => {
			if (emblaInstance.value && emblaInstance.value.canScrollNext()) {
				emblaInstance.value.scrollNext();
			} else {
				emblaInstance.value?.scrollTo(0);
			}
		}, autoplayInterval);
	};

	const stopAutoplay = () => {
		if (autoplayTimer) {
			clearInterval(autoplayTimer);
		}
	};

	onMounted(() => {
		if (emblaNode.value) {
			emblaInstance.value = EmblaCarousel(emblaNode.value, options);
			startAutoplay();
			window.addEventListener('keydown', handleKeyDown);
		}
	});

	onUnmounted(() => {
		stopAutoplay();
		emblaInstance.value?.destroy();
		window.removeEventListener('keydown', handleKeyDown);
	});

	return {
		emblaNode,
		emblaInstance,
		startAutoplay,
		stopAutoplay,
		scrollNext,
		scrollPrev,
	};
}
